export default "__VITE_ASSET__BgrzrUTF__"